import { render, staticRenderFns } from "./vs-form-geom-legend.vue?vue&type=template&id=2b0049d2&scoped=true"
import script from "./vs-form-geom-legend.vue?vue&type=script&lang=js"
export * from "./vs-form-geom-legend.vue?vue&type=script&lang=js"
import style0 from "./vs-form-geom-legend.vue?vue&type=style&index=0&id=2b0049d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0049d2",
  null
  
)

export default component.exports